import React from 'react';
import classNames from 'classnames';
import classes from './VideoResultScore.module.scss';

interface IProps {
    className: string;
    points: string;
    animationDuration: number;
}

export const VideoResultScore: React.FC<IProps> = (props) => {
    const ref = React.useRef();
    const animationRef = React.useRef();

    React.useEffect(() => {
        if (!props.animationDuration) {
            return;
        }
        animationRef.current = window.bounty.default({
            el: ref.current,
            value: props.points,
            letterSpacing: 1.1,
            duration: props.animationDuration * 1000,
        });
    }, []);

    return (
        <div ref={ref} className={classNames(props.className, classes.score)}>
            {props.points}
        </div>
    );
};
